export default function redirect({ next, store }) {
  if (store.getters.loggedIn) {
    return next({
      name: "Home",
    });
  }

  return next();
}
